/* eslint-disable import/no-anonymous-default-export */
export default {
  "field.name": "Name",
  "field.description": "Description",
  "field.status": "Status",
  "field.created_at": "Created at",
  "field.created_by": "Created by",
  "field.updated_at": "Updated at",
  "field.updated_by": "Updated by",
  "field.revision": "Revision",
  "field.active.true": "Active",
  "field.active.false": "Inactive",
  "field.search": "Search",
};
